import { render, staticRenderFns } from "./WatchWorkoutSyncNotice.vue?vue&type=template&id=bdb7fa86&scoped=true"
import script from "./WatchWorkoutSyncNotice.vue?vue&type=script&lang=js"
export * from "./WatchWorkoutSyncNotice.vue?vue&type=script&lang=js"
import style0 from "./WatchWorkoutSyncNotice.vue?vue&type=style&index=0&id=bdb7fa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb7fa86",
  null
  
)

export default component.exports